const rules = {
  trigger: "blur",
  enum: "",
  len: null,
  max: null,
  message: "",
  min: null,
  pattern: "",
  required: false,
  type: "any"
};
export const eventData = {
  topColumns1: [
    {
      title: "投票选项",
      dataIndex: "description",
      key: "description"
    },
    {
      title: "投票积分",
      dataIndex: "points",
      key: "points"
    },
    {
      title: "投票占比",
      dataIndex: "percentage",
      key: "percentage"
    }
  ],
  topColumns3: [
    {
      title: "问题回答",
      dataIndex: "description",
      key: "description"
    },
    {
      title: "回答问题人数",
      dataIndex: "number",
      key: "number"
    }
  ],
  bottomColumns1: [
    {
      title: "邮箱/手机号",
      dataIndex: "user",
      key: "user"
    },
    {
      title: "投票IP",
      dataIndex: "ip",
      key: "ip"
    },
    {
      title: "投票时间",
      dataIndex: "createdAt",
      key: "createdAt"
    },
    {
      title: "投票选项",
      dataIndex: "description",
      key: "description"
    },
    {
      title: "投票积分",
      dataIndex: "points",
      key: "points"
    }
  ],
  bottomColumns2: [
    {
      title: "邮箱/手机号",
      dataIndex: "user",
      key: "user"
    },
    {
      title: "登录方式",
      dataIndex: "userTypeText",
      key: "userTypeText"
    },
    // {
    //   title: "邀请数量",
    //   dataIndex: "number",
    //   key: "number"
    // },
    {
      title: "邀请时间",
      dataIndex: "inviteTime",
      key: "inviteTime"
    },
    {
      title: "被邀请登录人方式",
      dataIndex: "inviteUserTypeText",
      key: "inviteUserTypeText"
    },
    {
      title: "被邀请邮箱/手机号",
      dataIndex: "inviteUser",
      key: "inviteUser"
    }
  ],
  bottomColumns3: [
    {
      title: "邮箱/手机号",
      dataIndex: "user",
      key: "user"
    },
    {
      title: "答题时间",
      dataIndex: "createdAt",
      key: "createdAt"
    },
    {
      title: "问题内容",
      dataIndex: "description",
      key: "description"
    }
  ],
  bottomColumns4: [
    {
      title: "邮箱/手机号",
      dataIndex: "user",
      key: "user"
    },
    {
      title: "抽奖时间",
      dataIndex: "createdAt",
      key: "createdAt"
    },
    {
      title: "奖励选项",
      dataIndex: "description",
      key: "description"
    },
    {
      title: "是否中奖",
      dataIndex: "statusText",
      key: "statusText"
    },
    {
      title: "奖励码",
      dataIndex: "giftCode",
      key: "giftCode"
    }
  ]
};
export const rulesConfigInterface = [
  {
    type: "1"
  },
  {
    type: "4",
    inviteType: null
  },
  {
    type: "3"
  },
  {
    type: "2",
    lotteryType: 1
  }
];

export const WidgetFormInterface = {
  list: [],
  config: {
    size: "default",
    hideRequiredMark: false,
    layout: "horizontal",
    labelAlign: "right",
    lableCol: {
      span: 2,
      offset: 0
    }
  }
};
export const basicComponents = [
  {
    label: "文字",
    type: "text",
    icon: "t-box-line",
    labelKey: "",
    options: {
      defaultValue: "This is a text"
    }
  },
  {
    label: "输入框",
    type: "input",
    icon: "input-method-line",
    labelKey: "",
    options: {
      width: "100%",
      defaultValue: "",
      placeholder: "",
      maxlength: null,
      prefix: "",
      suffix: "",
      addonBefore: "",
      addonAfter: "",
      disabled: false,
      allowClear: false,
      readonly: false,
      rules
    }
  },
  {
    label: "文本域",
    type: "textarea",
    icon: "file-text-line",
    labelKey: "",
    options: {
      width: "100%",
      defaultValue: "",
      placeholder: "",
      maxlength: null,
      rows: 4,
      autoSize: false,
      showCount: false,
      disabled: false,
      allowClear: false,
      readonly: false,
      rules
    }
  },
  {
    label: "时间选择器",
    type: "time",
    icon: "calendar-2-line",
    labelKey: "",
    options: {
      defaultValue: "",
      width: "100%",
      placeholder: "请选择时间",
      format: "YYYY/MM/DD HH:mm:ss",
      valueFormat: "YYYY/MM/DD HH:mm:ss",
      readonly: false,
      allowClear: true,
      disabled: false,
      rules
    }
  },
  {
    label: "上传文件",
    type: "upload",
    icon: "chat-upload-line",
    labelKey: "",
    options: {
      defaultValue: [],
      name: "file",
      action: "http://example.com/upload",
      method: "post",
      listType: "text",
      accept: "image/*",
      maxCount: 3,
      multiple: false,
      disabled: false,
      fileList: [],
      rules
    }
  },
  {
    label: "单选框组",
    type: "radio",
    icon: "radio-button-line",
    labelKey: "",
    options: {
      defaultValue: "",
      width: "",
      inline: false,
      remote: false,
      showLabel: false,
      remoteFunc:
        "https://raw.githubusercontent.com/fuchengwei/vue-form-create/master/mock/mock.json",
      options: [
        {
          value: "Option 1",
          label: "Option 1",
          selected: false,
          id: 0
        },
        {
          value: "Option 2",
          label: "Option 2",
          selected: false,
          id: 1
        },
        {
          value: "Option 3",
          label: "Option 3",
          selected: false,
          id: 2
        }
      ],
      remoteOptions: [],
      props: {
        value: "value",
        label: "label"
      },
      disabled: false,
      rules
    }
  },
  {
    label: "多选框组",
    type: "checkbox",
    icon: "checkbox-line",
    labelKey: "",
    options: {
      defaultValue: [],
      width: "",
      inline: false,
      remote: false,
      showLabel: false,
      remoteFunc:
        "https://raw.githubusercontent.com/fuchengwei/vue-form-create/master/mock/mock.json",
      options: [
        {
          label: "Option 1",
          value: "Option 1",
          selected: false
        },
        {
          label: "Option 2",
          value: "Option 2",
          selected: false
        },
        {
          label: "Option 3",
          value: "Option 3",
          selected: false
        }
      ],
      remoteOptions: [],
      props: {
        value: "value",
        label: "label"
      },
      disabled: false,
      rules
    }
  }
  // {
  //   label: "密码框",
  //   type: "password",
  //   icon: "text",
  //   options: {
  //     width: "100%",
  //     defaultValue: "",
  //     placeholder: "",
  //     maxlength: null,
  //     prefix: "",
  //     suffix: "",
  //     addonBefore: "",
  //     addonAfter: "",
  //     visibilityToggle: true,
  //     disabled: false,
  //     allowClear: false,
  //     readonly: false,
  //     rules
  //   }
  // },
  // {
  //   label: "计数器",
  //   type: "number",
  //   icon: "text",
  //   options: {
  //     width: "",
  //     defaultValue: 0,
  //     min: 0,
  //     max: 100,
  //     step: 1,
  //     readonly: false,
  //     disabled: false,
  //     rules
  //   }
  // },

  // {
  //   label: "日期选择器",
  //   type: "date",
  //   icon: "text",
  //   options: {
  //     defaultValue: "",
  //     width: "",
  //     placeholder: "请选择时间",
  //     format: "YYYY-MM-DD",
  //     readonly: false,
  //     allowClear: true,
  //     disabled: false,
  //     rules
  //   }
  // },
  // {
  //   label: "评分",
  //   type: "rate",
  //   icon: "text",
  //   options: {
  //     defaultValue: null,
  //     max: 5,
  //     allowClear: true,
  //     allowHalf: false,
  //     disabled: false,
  //     rules
  //   }
  // },
  // {
  //   label: "下拉选择框",
  //   type: "select",
  //   icon: "text",
  //   options: {
  //     defaultValue: [],
  //     width: "200px",
  //     mode: null,
  //     placeholder: "",
  //     remote: false,
  //     showLabel: false,
  //     showSearch: false,
  //     clearable: false,
  //     disabled: false,
  //     props: {
  //       label: "label",
  //       value: "value"
  //     },
  //     options: [
  //       {
  //         label: "Option 1",
  //         value: "Option 1"
  //       },
  //       {
  //         label: "Option 2",
  //         value: "Option 2"
  //       },
  //       {
  //         label: "Option 3",
  //         value: "Option 3"
  //       }
  //     ],
  //     remoteOptions: [],
  //     remoteFunc:
  //       "https://raw.githubusercontent.com/fuchengwei/vue-form-create/master/mock/mock.json",
  //     rules
  //   }
  // },
  // {
  //   label: "开关",
  //   type: "switch",
  //   icon: "text",
  //   options: {
  //     defaultValue: false,
  //     disabled: false,
  //     checkedChildren: "",
  //     unCheckedChildren: "",
  //     rules
  //   }
  // },
  // {
  //   label: "滑块",
  //   type: "slider",
  //   icon: "text",
  //   options: {
  //     defaultValue: 0,
  //     width: "",
  //     min: 0,
  //     max: 100,
  //     step: 1,
  //     disabled: false,
  //     range: false,
  //     reverse: false,
  //     rules
  //   }
  // }
];
